(() => {
  const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (!isTouch) return;
  
// Prevent long-press context menu on PRODUCT IMAGES only
document.addEventListener('contextmenu', (e) => {
  if (e.target.closest('.card__media, .media')) {
    e.preventDefault();
  }
}, { passive: false });

  const CARD_SELECTOR = '.card, .card-wrapper, .product-card, .grid__item';
  let activeCard = null;

  const hasSecondImage = (card) => {
    const hoverWrap = card.querySelector('.media--hover-effect');
    if (!hoverWrap) return false;
    return hoverWrap.querySelectorAll('img').length >= 2;
  };

  const clear = () => {
    if (activeCard) activeCard.classList.remove('nhny-touch-preview');
    activeCard = null;
  };

  document.addEventListener('touchstart', (e) => {
    const card = e.target.closest(CARD_SELECTOR);
    if (!card) return;
    if (!hasSecondImage(card)) return;

    if (activeCard && activeCard !== card) {
      activeCard.classList.remove('nhny-touch-preview');
    }

    activeCard = card;
    activeCard.classList.add('nhny-touch-preview');
  }, { passive: true });

  document.addEventListener('touchend', clear, { passive: true });
  document.addEventListener('touchcancel', clear, { passive: true });
  document.addEventListener('touchmove', clear, { passive: true });
})();
